import {apiRedux} from "../reducers/apiRedux";
import {apiUrls} from "../../constants/appUrls";

const MenuApi = apiRedux.injectEndpoints({
  endpoints: (build) => ({
    getMenuList: build.query({
      query: () => ({
        url: apiUrls.getMenuUrl
      }),
      keepUnusedDataFor: 2,
    }),
    getMenuInformer: build.query({
      query: () => ({
        url: apiUrls.getMenuInformer
      }),
      keepUnusedDataFor: 2,
    })


  })
});

export const {useGetMenuListQuery} = MenuApi;
export const {useGetMenuInformerQuery} = MenuApi;

